module.exports = __webpack_public_path__ + "media/src/images/icons/lightning_bolt-c779172edd66426dcb84c444d6096a75.svg";